module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day01_05_stay-ae2b67fe28321309ccc1df2dfc684f4a.jpg";